/* eslint-disable  */
import {
  Close,
  DashboardOutlined,
  FavoriteBorderOutlined,
  LiveHelp,
  Lock,
  Message,
  MoneyOutlined,
  Person,
  Receipt,
  Settings,
  SettingsApplicationsOutlined,
} from "@material-ui/icons";

import React, { useEffect, useState } from "react";
import { BsBasketFill, BsCalculator } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import {
  GiPayMoney,
  GiReceiveMoney,
  GiShoppingCart,
  GiTakeMyMoney,
} from "react-icons/gi";
import { GoListUnordered } from "react-icons/go";
import { SiGooglemessages } from "react-icons/si";
import { TiShoppingCart } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import "../../../../css/Dashboard/home/Home.css";
import { navigationActionCreators } from "../../../../service/action-creators";
import { FaGlobe, FaSlack, FaWpforms } from "react-icons/fa";
import Modal from "../../../Modal/Modal";

function SideBarMenu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const navigation = useSelector((state) => state.navigation.openSideNav);
  const messages = useSelector((state) => state?.messages);
  const user = useSelector((state) => state.user);

  const display = navigation ? "block" : "none";
  const device = () => {
    return window.innerWidth < 1080;
  };
  const [isMobile, setIsMobile] = useState(device);
  const [openLoanRestriction, setOpenLoanRestriction] = useState(false);
  const [loanRestrictionMessage, setLoanRestrictionMessage] = useState("");

  const { closeSideBarOnMobile } = bindActionCreators(
    navigationActionCreators,
    dispatch
  );

  // Function to check if user can apply for a new loan
  const canApplyForLoan = () => {
    if (!user?.myAppliedLoans || user.myAppliedLoans.length === 0) {
      return { canApply: true, message: "" };
    }

    // Check for loans that are not rejected or paid
    const restrictiveLoan = user.myAppliedLoans.find((loan) => {
      return loan.status !== "rejected" && loan.status !== "paid";
    });

    if (restrictiveLoan) {
      let message = "";

      // Customize message based on current loan status
      switch (restrictiveLoan.status) {
        case "submitted":
          message =
            "You have already submitted a loan application. Please wait for it to be processed.";
          break;
        case "booked":
          message =
            "Your loan application has been booked. Please wait for further processing.";
          break;
        case "initiated":
          message = "Your loan has been initiated. Please wait for completion.";
          break;
        case "authorized":
          message =
            "Your loan has been authorized. Please wait for disbursement.";
          break;
        default:
          message = `You have an active loan application with status: ${restrictiveLoan.status}. Please wait for it to be completed or contact support.`;
      }

      return {
        canApply: false,
        message: message,
      };
    }

    return { canApply: true, message: "" };
  };
  // Function to check if user can place a new order
  // const canPlaceOrder = () => {
  //   if (!user?.orders || user.orders.length === 0) {
  //     return { canApply: true, message: "" };
  //   }

  //   // Check for any active (non-rejected, non-delivered) orders
  //   const restrictiveOrder = user.orders.find((order) => {
  //     return order.status !== "rejected" && order.status !== "shipped";
  //   });

  //   if (restrictiveOrder) {
  //     const message = `You already have an order with status: ${restrictiveOrder.status}. Please wait until it's processed.`;
  //     return {
  //       canApply: false,
  //       message,
  //     };
  //   }

  //   return { canApply: true, message: "" };
  // };

  // Handle loan application click
  const handleLoanApplicationClick = (e) => {
    e.preventDefault();
    const loanCheck = canApplyForLoan();

    if (loanCheck.canApply) {
      history.push("/apply-loan-personal_info");
    } else {
      setLoanRestrictionMessage(loanCheck.message);
      setOpenLoanRestriction(true);
    }
  };

  const handleOrderClick = (e) => {
    // e.preventDefault();
    // const orderCheck = canPlaceOrder();

    // if (orderCheck.canApply) {
    history.push("/upnmg-shopping-mall");
    // } else {
    //   setLoanRestrictionMessage(orderCheck.message);
    //   setOpenLoanRestriction(true);
    // }
  };

  console.log("navigation", navigation);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(device);
    });
    return 0;
  }, []);

  return (
    <>
      <div
        className="SideBarMenu"
        style={{
          display: `${isMobile ? display : ""}`,
          background:
            "url(/images/dev/background.jpg) no-repeat center center/cover",
        }}
      >
        <div className="overlay">
          <div className="title_nd_closeBtn">
            <div className="mb4 pt2">
              {/* <img
                src={"/images/dev/logo.png"}
                style={{
                  width: "100px",
                }}
              /> */}
            </div>
            <div className="hide_on_large">
              <span
                onClick={() => {
                  closeSideBarOnMobile();
                }}
              >
                <Close
                  className="mx-3 my-2"
                  style={{ marginTop: "-20px", color: "white" }}
                />
              </span>
            </div>
          </div>
          <ul>
            <Link to="/home">
              <div className="icon">
                <DashboardOutlined />
              </div>
              <div>Dashboard</div>
            </Link>

            <Link to={"/loans"}>
              <div className="icon">
                <GiTakeMyMoney size={22} />
              </div>

              <div>Loans Deduction</div>
            </Link>
            <Link to={"/mart-deduction"}>
              <div className="icon">
                <MoneyOutlined size={22} />
              </div>
              <div>Mart Deduction</div>
            </Link>

            <Link to={"/fund"}>
              <div className="icon">
                <GiPayMoney size={22} />
              </div>
              <div>My Contributions</div>
            </Link>

            <Link to={"/fund-increment"}>
              <div className="icon">
                <GiPayMoney size={22} />
              </div>
              <div>Increase / Decrease Fund</div>
            </Link>

            <Link
              to={"/apply-loan-personal_info"}
              onClick={handleLoanApplicationClick}
              style={{ cursor: "pointer" }}
            >
              <div className="icon">
                <GiReceiveMoney size={22} />
              </div>
              <div>Apply Loan</div>
            </Link>

            <Link to={"/my-applied-loans"}>
              <div className="icon">
                <GoListUnordered className="" size={20} />
              </div>
              <div>My applied Loans</div>
            </Link>
            <Link to={"/profile"}>
              <div className="icon">
                <CgProfile size={22} />
              </div>
              <div>My Profile</div>
            </Link>

            <Link to={"/upnmg-shopping-mall"} onClick={handleOrderClick}>
              <div className="icon">
                {/* <ShoppingBasketOutlined /> */}
                <TiShoppingCart size={23} />
              </div>
              <div>UPNMG Mart</div>
            </Link>
            <Link to={"/my-orders-and-purchase"}>
              <div className="icon">
                <FaWpforms className="" size={20} />
              </div>
              <div>My Orders </div>
            </Link>
            <Link to={"/favourites"}>
              <div className="icon">
                <FavoriteBorderOutlined />
              </div>
              <div>My Favourites</div>
            </Link>
            <Link to={"/my-cart"}>
              <div className="icon">
                <GiShoppingCart size={23} />
                {/* <ShoppingBasketOutlined /> */}
              </div>
              <div>My Cart</div>
            </Link>

            {/* TODO:: WE HAVE HIDE THE REQUESTED FOR FUTURE UPDATES */}
            {/* <Link to={"/request-order"}>
              <div className="icon">
                <FaSlack className="" size={20} />
              </div>
              <div>Request Order </div>
            </Link> */}

            <Link to={"/message"}>
              <div className="icon">
                <SiGooglemessages className="" size={20} />
              </div>
              <div>Messenger ({`${messages?.unreadMessagesTotal}`})</div>
            </Link>
            <Link to={"/calculator"}>
              <div className="icon">
                <BsCalculator className="" size={20} />
              </div>
              <div>Loan Calculator</div>
            </Link>
            <hr />

            <Link to={"/settings"}>
              <div className="icon">
                <Settings />
              </div>
              <div>Settings</div>
            </Link>
            <Link to={"/faq"}>
              <div className="icon">
                <LiveHelp />
              </div>
              <div>
                FAQ<small>s</small>
              </div>
            </Link>
            <a href="https://upnmg.com" target="_blank">
              <div className="icon">
                <FaGlobe />
              </div>
              <div>UPNMG WEBSITE</div>
            </a>

            <Link to={"/logout"}>
              <div className="icon">
                <Lock />
              </div>
              <div>Logout</div>
            </Link>
          </ul>
        </div>
      </div>

      {/* Loan Restriction Modal */}
      {openLoanRestriction && (
        <Modal
          title={"Loan Application Restricted"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setOpenLoanRestriction}
        >
          <div className="modalBody">
            <div className="text-center">
              <p>{loanRestrictionMessage}</p>
            </div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button
                type="button"
                onClick={() => setOpenLoanRestriction(false)}
                className="modalBtn"
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default SideBarMenu;
